import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { connect } from 'react-redux';
import { addUserChange } from '../actions/Users';

class AddSecurityCodeForm extends Component {
  onAddedUserChange = ev => {
    const { value } = ev.target;
    this.props.addUserChange({ name: 'security', value: value });
  };
  render() {
    return (
      <div className="container">
        <label className="w-100">
          <span className="mb-1 d-inline-block"> Security Code :</span>
          <Input
            id="security_modal"
            placeholder="Please specify"
            required
            type="password"
            name="security"
            value={this.props.security}
            onChange={this.onAddedUserChange}
            autoComplete="off"
          />
        </label>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    security: state.UIState.users.addedUser.security,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addUserChange: userData => dispatch(addUserChange(userData)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddSecurityCodeForm);
